import { z } from 'zod'
import { validationRules, enumError } from './validationRules'
import { Response } from './models'
import { Prisma } from '@prisma/models'
import { AssignType } from './enums'

export const caseSchema = z.object({
  ////////////////**************** DUPLICATE IN caseImportSchema.ts ****************////////////////
  case_description: validationRules.safeTextarea,
  entity_gstin: validationRules.gstin,
  entity: z.object({
    value: validationRules.objectId,
    label: validationRules.safeString,
  }),
})

export const caseAssignSchema = z.object({
  userId: validationRules.objectId,
  assignType: z.nativeEnum(AssignType, enumError),
})

export const caseUpdateSchema = caseSchema

export type ICase = Prisma.CaseGetPayload<{
  include: {
    assignedToUser: true;
    reviewUser: true;
    caseStages: {
      include: {
        sub_stages: true
      }
    }
  }
}>

export type ICaseUpdate = Omit<Prisma.CaseUpdateInput, 'case_no' | 'caseStages' | 'sub_stages'>
export type ICaseForm = z.infer<typeof caseSchema>
export type ICaseAssignForm = z.infer<typeof caseAssignSchema>

export type CasesQueryResponse = Response<Array<ICase>>
